import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@istari-frontend/ui";

interface ChatSaveResourceConfirmDialogProps {
  fileName: string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ChatSaveResourceConfirmDialog({
  fileName,
  open,
  onConfirm,
  onCancel,
}: ChatSaveResourceConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Save as new resource</DialogTitle>
          <DialogDescription>“{fileName}” will be saved as a new resource.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onConfirm}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
